import React, { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Home from "../pages/Home/Home";
import PageNotFound from "../pages/Settings/PageNotFound";
import PendingLoader from "../Components/PendingLoader";
import ContentReveal from "../Components/ContentReveal";

const UserAuthentication = lazy(() => import("../pages/Customers/Authentication/UserAuthentication"));
const ForgetPassword = lazy(() => import("../pages/Customers/Authentication/ForgetPassword"));
const ResetPassword = lazy(() => import("../pages/Customers/Authentication/ResetPassword"));
const Profile = lazy(() => import("../pages/Profile/Profile"));
const Cart = lazy(() => import("../pages/Customers/Cart/Cart"));
const Checkout = lazy(() => import("../pages/Customers/Cart/Checkout"));
const OrderTracking = lazy(() => import("../pages/Customers/Cart/OrderTracking"));
const WishList = lazy(() => import("../pages/Customers/WishList/WishList"));
const DetailedProduct = lazy(() => import("../pages/Products/DetailedProduct"));
const ListProducts = lazy(() => import("../pages/Products/ListProducts"));
const Services = lazy(() => import("../pages/Services/Service"));
const ServiceDetails = lazy(() => import("../pages/Services/ServiceDetails"));
const DealBundles = lazy(() => import("../pages/Products/DealBundles"));
const Returns = lazy(() => import("../pages/Settings/Returns"));
const FAQs = lazy(() => import("../pages/Settings/FAQs"));
const CustomerService = lazy(() => import("../pages/Settings/CustomerService"));
const EmailConfirmation = lazy(() => import("../pages/Customers/Authentication/EmailConfirmation"));
const CategoryList = lazy(() => import("../pages/Products/CategoryList"));
const SearchedProduct = lazy(() => import("../pages/Products/SearchedProduct"));
const Products = lazy(() => import("../pages/Products/Products"));
const Pagination = lazy(() => import("../pages/Products/Pagination"));
const ProductDetails = lazy(() => import("../pages/Products/ProductDetails"));
const TermsAndConditions = lazy(() => import("../pages/Settings/TermsAndConditions"));
const ThankYouPopUp = lazy(() => import("../pages/Customers/Cart/ThankYouPopUp"));


const AppRoute = (props) => {
  const location = useLocation();
  // the product and category pages show their content as it arrives, without the page loader
  const noLoader = location.pathname.startsWith("/DetailedProduct") || location.pathname.startsWith("/Category/");
  const Wrapper = noLoader ? React.Fragment : ContentReveal;
  return (
    <>
    <Wrapper key={noLoader ? "no-loader" : location.pathname}>
      <Suspense fallback={noLoader ? null : <PendingLoader />}>
      <Routes>
        <Route path="/" element={<Home
          wishListCount={props.wishListCount}
          cartCount={props.cartCount}
          setCartCount={props.setCartCount}
          setWishListCount={props.setWishListCount}
          cartItem={props.cartItem}
          setCartItem={props.setCartItem}
          setWishListItem={props.setWishListItem}
          wishListItem={props.wishListItem}
          headerTitle = {props.headerTitle}
          setHeaderTitle = {props.setHeaderTitle}
          footerActive = {props.footerActive}
          setFooterActive = {props.setFooterActive}
        />}></Route>
        <Route path="/UserAuthentication" element={<UserAuthentication
          customerDetail={props.customerDetail}
          setCustomerDetail={props.setCustomerDetail}
          subscribe={props.subscribe}
          setSubscribe={props.setSubscribe}
          headerTitle = {props.headerTitle}
          setHeaderTitle = {props.setHeaderTitle}
          footerActive = {props.footerActive}
          setFooterActive = {props.setFooterActive}
        />}></Route>
        <Route path="/Forget-Password" element={<ForgetPassword
         headerTitle = {props.headerTitle}
         setHeaderTitle = {props.setHeaderTitle}
         footerActive = {props.footerActive}
         setFooterActive = {props.setFooterActive} />}></Route>
        <Route path="/ThankYouPopUp" element={<ThankYouPopUp
         headerTitle = {props.headerTitle}
         setHeaderTitle = {props.setHeaderTitle}
         footerActive = {props.footerActive}
         setFooterActive = {props.setFooterActive} />}></Route>
        <Route path="/Email-Confirmation" element={<EmailConfirmation
         headerTitle = {props.headerTitle}
         setHeaderTitle = {props.setHeaderTitle}
         footerActive = {props.footerActive}
         setFooterActive = {props.setFooterActive} />}></Route>
        <Route path="/Reset-Password" element={<ResetPassword
          customerDetail={props.customerDetail}
          setCustomerDetail={props.setCustomerDetail}
          subscribe={props.subscribe}
          setSubscribe={props.setSubscribe}
          headerTitle = {props.headerTitle}
          setHeaderTitle = {props.setHeaderTitle}
          footerActive = {props.footerActive}
          setFooterActive = {props.setFooterActive}
        />}></Route>
        <Route path="/Services" element={<Services
         headerTitle = {props.headerTitle}
         setHeaderTitle = {props.setHeaderTitle}
         footerActive = {props.footerActive}
         setFooterActive = {props.setFooterActive} />}></Route>
        <Route path="/Profile" element={<Profile
         headerTitle = {props.headerTitle}
         setHeaderTitle = {props.setHeaderTitle}
         footerActive = {props.footerActive}
         setFooterActive = {props.setFooterActive} />}></Route>

        <Route path="/WishList" element={<WishList
         headerTitle = {props.headerTitle}
         setHeaderTitle = {props.setHeaderTitle}
         footerActive = {props.footerActive}
         setFooterActive = {props.setFooterActive} />}></Route>
        <Route path="/Cart" element={<Cart
         headerTitle = {props.headerTitle}
         setHeaderTitle = {props.setHeaderTitle}
         footerActive = {props.footerActive}
         setFooterActive = {props.setFooterActive} />}></Route>
        <Route path="/Checkout" element={<Checkout
         headerTitle = {props.headerTitle}
         setHeaderTitle = {props.setHeaderTitle}
         footerActive = {props.footerActive}
         setFooterActive = {props.setFooterActive} />}></Route>
        <Route path="/Order-Tracking" element={<OrderTracking
         headerTitle = {props.headerTitle}
         setHeaderTitle = {props.setHeaderTitle}
         footerActive = {props.footerActive}
         setFooterActive = {props.setFooterActive} />}></Route>
        <Route path="/Deal-Bundles" element={<DealBundles
         headerTitle = {props.headerTitle}
         setHeaderTitle = {props.setHeaderTitle}
         footerActive = {props.footerActive}
         setFooterActive = {props.setFooterActive} />}></Route>
        <Route path="/Returns" element={<Returns
         headerTitle = {props.headerTitle}
         setHeaderTitle = {props.setHeaderTitle}
         footerActive = {props.footerActive}
         setFooterActive = {props.setFooterActive} />}></Route>
        <Route path="/FAQs" element={<FAQs
         headerTitle = {props.headerTitle}
         setHeaderTitle = {props.setHeaderTitle}
         footerActive = {props.footerActive}
         setFooterActive = {props.setFooterActive} />}></Route>
        <Route path="/Customer-Service" element={<CustomerService
         headerTitle = {props.headerTitle}
         setHeaderTitle = {props.setHeaderTitle}
         footerActive = {props.footerActive}
         setFooterActive = {props.setFooterActive} />}></Route>

        <Route path="/Category/:CategoryName/:CategoryId" element={<ListProducts
         headerTitle = {props.headerTitle}
         setHeaderTitle = {props.setHeaderTitle}
         footerActive = {props.footerActive}
         setFooterActive = {props.setFooterActive} />}></Route>
        <Route path="/DetailedProduct/:ProductName/:ProductId/:ProductVariationId" element={<DetailedProduct
         headerTitle = {props.headerTitle}
         setHeaderTitle = {props.setHeaderTitle}
         footerActive = {props.footerActive}
         setFooterActive = {props.setFooterActive} />}></Route>
           {/* <Route path="/SearchedProduct/:Term?" element={<SearchedProduct
         headerTitle = {props.headerTitle}
         setHeaderTitle = {props.setHeaderTitle}
         footerActive = {props.footerActive}
         setFooterActive = {props.setFooterActive} />}></Route> */}
           <Route path="/SearchedProduct/:id?" element={<SearchedProduct
         headerTitle = {props.headerTitle}
         setHeaderTitle = {props.setHeaderTitle}
         footerActive = {props.footerActive}
         setFooterActive = {props.setFooterActive} />}></Route>
          {/* <Route path="/SearchedProduct" element={<Products
         headerTitle = {props.headerTitle}
         setHeaderTitle = {props.setHeaderTitle}
         footerActive = {props.footerActive}
         setFooterActive = {props.setFooterActive} />}></Route> */}
          <Route path="/Pagination/" element={<Pagination
         headerTitle = {props.headerTitle}
         setHeaderTitle = {props.setHeaderTitle}
         footerActive = {props.footerActive}
         setFooterActive = {props.setFooterActive} />}></Route>
        <Route path="/ServiceDetails" element={<ServiceDetails
         headerTitle = {props.headerTitle}
         setHeaderTitle = {props.setHeaderTitle}
         footerActive = {props.footerActive}
         setFooterActive = {props.setFooterActive} />}></Route>
        <Route path="/Category-List" element={<CategoryList
         headerTitle = {props.headerTitle}
         setHeaderTitle = {props.setHeaderTitle}
         footerActive = {props.footerActive}
         setFooterActive = {props.setFooterActive} />}></Route>
         {/* <Route path="*" element={<Navigate to="/" replace />} /> */}
         <Route path="/TermsAndConditions" element={<TermsAndConditions />} />
         <Route path="*" element={<PageNotFound />} />
      </Routes>
      </Suspense>
    </Wrapper>

    </>
  );
};
export default AppRoute;
